<ion-content>
  <div class="pop-up-content">
    <!-- Banner Image -->
    @if (popupInfo.bannerImg) {
      <div class="banner" 
           [class.medium-size]="popupInfo.iconSize === 2" 
           [class.small-size]="popupInfo.iconSize === 3"
           [ngStyle]="{'background': popupInfo.bannerColor}">
        <img [src]="popupInfo.bannerImg" alt="Banner" class="icon-text-secondary">
      </div>
    }

    <!-- Icon -->
    @if (popupInfo.icon) {
      <div class="img" 
           [class.medium-size]="popupInfo.iconSize === 2" 
           [class.small-size]="popupInfo.iconSize === 3">
        <img [src]="popupInfo.icon" alt="Icon" class="icon-text-secondary">
      </div>
    }

    <!-- Titles -->
    @if (popupInfo.titleh2) {
      <h2 class="h2-bold text-secondary text-center">{{ popupInfo.titleh2 }}</h2>
    }
    @if (popupInfo.title1) {
      <h4 class="h4-bold text-secondary text-center">{{ popupInfo.title1 }}</h4>
    }
    @if (popupInfo.title2) {
      <h4 class="h4-bold text-secondary text-center">{{ popupInfo.title2 }}</h4>
    }
    @if (popupInfo.title3) {
      <h5 class="h5-bold text-secondary text-center">
        <hr>{{ popupInfo.title3 }}
      </h5>
    }

    <!-- Body Text -->
    @if (popupInfo.bodyText) {
      <p class="p main-text" [innerHTML]="popupInfo.bodyText"></p>
    }

    <!-- Button 3 (tertiary) -->
    @if (popupInfo.btn3 && !timerEnable) {
      <div class="push-btn tertiary-btn" (click)="dismiss(3)">
        <div class="inner-button">
          <span class="btn-text p-semibold">{{ popupInfo.btn3 }}</span>
        </div>
      </div>
    }

    <!-- Button 1 (primary) -->
    @if (popupInfo.btn1) {
      <div class="push-btn btn1 btn-m full-width-button" 
           [class.primary-color-button]="popupInfo.btn1Style === 1 || !popupInfo.btn1Style"
           [class.secondary-btn]="popupInfo.btn1Style === 2"
           (click)="dismiss(1, url1, urlBack1)">
        <div class="inner-button">
          <span class="btn-text p-semibold">{{ popupInfo.btn1 }}</span>
        </div>
      </div>
    }

    <!-- Button 2 (secondary/cancel) -->
    @if (popupInfo.btn2) {
      <div class="btn2-link btn-sm" (click)="dismiss(2)">
        @if (timerEnable) {
          <span class="p">{{ btn2 }} {{ timer }} s</span>
        } @else {
          <span class="p">{{ btn2 }}</span>
        }
      </div>
    }
  </div>
</ion-content>